import { forwardRef } from 'react';
import { IntegerInput } from '../__internal__/IntegerInput';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useFormatLocale } from '../../../locale/formatting/useFormatLocale';
import { isThaiLocale } from '../../../locale/localeUtils';
import { MAX_GREGORIAN_CALENDAR_YEAR, MIN_GREGORIAN_CALENDAR_YEAR } from '../../Calendar/GregorianCalendarFacts';
import { withLabels } from '../../withLabels';
import { convertGregorianYearToThaiYear, getYearOfWeek } from '../DateUtil';
import bundle from '../NovaComponents-DatePicker-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const IntegerInputWithLabels = withLabels(IntegerInput);
const useTextLocalizer = createUseTextLocalizer(bundle);
export const YearInput = /*#__PURE__*/forwardRef(function YearInput(props, ref) {
  const locale = useFormatLocale();
  const localize = useTextLocalizer();
  const minYearValue = !props.minDate ? MIN_GREGORIAN_CALENDAR_YEAR : isThaiLocale(locale) ? convertGregorianYearToThaiYear(props.minDate?.getFullYear()) : props.type === 'week' ? getYearOfWeek(props.minDate, locale) : props.minDate?.getFullYear();
  const maxYearValue = !props.maxDate ? MAX_GREGORIAN_CALENDAR_YEAR : isThaiLocale(locale) ? convertGregorianYearToThaiYear(props.maxDate?.getFullYear()) : props.type === 'week' ? getYearOfWeek(props.maxDate, locale) : props.maxDate?.getFullYear();
  return /*#__PURE__*/_jsx(IntegerInputWithLabels, {
    testId: props.testId,
    ref: ref,
    id: props.id,
    label: localize('year.label'),
    labelPosition: "top",
    invalidMessageKey: "invalidyear.msg",
    value: props.value,
    onChange: props.onChange,
    minValue: minYearValue,
    maxValue: maxYearValue,
    wrapLabel: false,
    fieldWidth: "4.5rem"
  });
});
//# sourceMappingURL=YearInput.js.map